import { render, staticRenderFns } from "./CustomDefinedFieldsDisplay.vue?vue&type=template&id=5882631e"
import script from "./CustomDefinedFieldsDisplay.vue?vue&type=script&lang=ts"
export * from "./CustomDefinedFieldsDisplay.vue?vue&type=script&lang=ts"
import style0 from "./CustomDefinedFieldsDisplay.vue?vue&type=style&index=0&id=5882631e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports